import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Fängt Darstellungsfehler ab, damit ein Fehler in einer Ansicht nicht die
 * ganze Anwendung auf eine weiße Seite wirft — der Plan muss weiter bedienbar
 * bleiben, notfalls nach einem Klick auf "Erneut versuchen".
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unerwarteter Fehler in der Oberfläche:', error, info.componentStack);
  }

  private reset = () => this.setState({ error: null });

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="view">
        <div className="card" style={{ padding: 'var(--space-6)' }}>
          <div className="stack">
            <h2>Es ist ein Fehler aufgetreten</h2>
            <p className="muted">
              Die Ansicht konnte nicht dargestellt werden. Die gespeicherten Daten sind davon nicht
              betroffen.
            </p>
            <pre
              style={{
                margin: 0,
                padding: 'var(--space-3)',
                background: 'var(--surface-sunken)',
                borderRadius: 'var(--radius)',
                color: 'var(--ink-muted)',
                fontSize: 'var(--text-tiny)',
                overflowX: 'auto',
              }}
            >
              {error.message}
            </pre>
            <div className="row">
              <button type="button" className="btn btn-primary" onClick={this.reset}>
                Erneut versuchen
              </button>
              <button type="button" className="btn" onClick={() => window.location.reload()}>
                Seite neu laden
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
